import React, { useMemo } from 'react';

export default function HomeSectionList({
  sections,
  applySectionOrder,
  pinToTop,
  resetOrder,
  hasCustomOrder,
}) {
  const ordered = useMemo(
    () => applySectionOrder(sections.filter(s => s.isVisible)),
    [sections, applySectionOrder],
  );

  const topSectionId = ordered[0]?.id;

  return (
    <>
      {ordered.map((section) => {
        const onPinToTop = topSectionId !== section.id ? () => pinToTop(section.id) : undefined;
        return (
          <React.Fragment key={section.id}>
            {section.render(onPinToTop)}
          </React.Fragment>
        );
      })}
      {hasCustomOrder && (
        <button
          type="button"
          onClick={resetOrder}
          className="w-full text-center mt-2 mb-4 transition-colors hover:opacity-80"
          style={{
            fontSize: 11,
            color: 'var(--text-secondary)',
            background: 'none',
            border: 'none',
            cursor: 'pointer',
            letterSpacing: '0.04em',
          }}
        >
          Reset home layout
        </button>
      )}
    </>
  );
}
